import axios from "axios";

export const state = {
    products: [],
};

export const getters = {
    products: state => state.products,
};

export const mutations = {
    setProducts(state, newValue) {
        state.products = newValue
    },
};

export const actions = {
    fetchProducts({ commit }) {
        axios.get('/products').then(res => {
            commit('setProducts', res.data.products);
        })
    },

    fetchCanteenProducts({ commit }) {
        axios.get('/canteenproducts').then(res => {
            commit('setProducts', res.data.products);
        })
    },

    filterProducts({ commit }, {search}) {
        let formData = new FormData();
        formData.append("name", search);
        axios.post('/filterproducts',formData).then(res => {
            commit('setProducts', res.data.products)
        })
    },
};
